import React from 'react';
import { useTranslation } from 'react-i18next';
import { InterestGender } from '../../common/enums/InterestGender';
import { StatusBadge } from '../Shared/StatusBadge/StatusBadge';

interface GenderBadgeProps {
  gender: InterestGender;
}

export const GenderBadge: React.FC<GenderBadgeProps> = ({ gender }) => {
  const { t } = useTranslation();
  return (
    <StatusBadge variant="neutral">
      {t(`istiftaLinks.gender.${gender}`)}
    </StatusBadge>
  );
};
